import React, { FC, memo, use } from 'react'
import { Trans, useTranslation } from 'react-i18next'
import styled from 'styled-components'

import BronzeIcon from 'assets/svg/referrals/bronze.svg'
import SuccessIcon from 'assets/svg/referrals/success.svg'
import Badge from 'components/Badge'
import BaseModal from 'components/BaseModal'
import Button from 'components/Button'
import { FlexDivCol, FlexDivColCentered, FlexDivRow } from 'components/layout/flex'
import Spacer from 'components/Spacer'
import { Body, Heading } from 'components/Text'

type Props = {
	onDismiss(): void
}

const ReferrerHeader = memo(() => {
	const { t } = useTranslation()
	return (
		<FlexDivCol>
			{t('referrals.affiliates.modal.referrer.title')}
			<FlexDivRow justifyContent="flex-start" columnGap="10px">
				<Body mono size="xsmall">
					0x8e2...78d23
				</Body>
				<Badge color="yellow">{t('referrals.affiliates.modal.nft-preview.tier-1')}</Badge>
			</FlexDivRow>
		</FlexDivCol>
	)
})

const MintCompleted = memo(() => {
	const { t } = useTranslation()
	return (
		<FlexDivColCentered>
			<Spacer height={30} />
			<SuccessIcon />
			<Spacer height={5} />
			<Heading variant="h4">{t('referrals.affiliates.modal.referrer.congratulations')}</Heading>
			<Spacer height={5} />
			<Body size="large" color="primary">
				<Trans
					i18nKey="referrals.affiliates.modal.referrer.mint-message"
					components={[<Emphasis />]}
				/>
			</Body>
			<Spacer height={30} />
			<FlexDivColCentered>
				<BronzeIcon width={240} height={240} />
				<div style={{ width: '45px', marginTop: '-10px' }}>
					<Badge color="yellow">{t('referrals.affiliates.modal.nft-preview.tier-1')}</Badge>
				</div>
			</FlexDivColCentered>
			<Spacer height={30} />
			<Body size="medium" color="primary" style={{ textAlign: 'center' }}>
				<Trans
					i18nKey="referrals.affiliates.modal.referrer.earn-boost"
					components={[<Emphasis />]}
				/>
			</Body>
			<Body size="medium" color="primary" style={{ textAlign: 'center' }}>
				<Trans
					i18nKey="referrals.affiliates.modal.referrer.stake-more"
					components={[<Emphasis />]}
				/>
			</Body>
			<Spacer height={30} />
			<Button
				data-testid="referrals.affiliates.modal.referrer.trade-now-button"
				variant="flat"
				disabled={false}
				loading={false}
				textTransform="none"
				fullWidth
				onClick={() => {}}
			>
				<FlexDivRow columnGap="10px">
					{t('referrals.affiliates.modal.referrer.trade-now-button')}
				</FlexDivRow>
			</Button>
		</FlexDivColCentered>
	)
})

const Minting = memo(() => {
	const { t } = useTranslation()
	return (
		<FlexDivColCentered>
			<Spacer height={30} />
			<SuccessIcon />
			<Spacer height={5} />
			<Heading variant="h4">{t('referrals.affiliates.modal.referrer.congratulations')}</Heading>
			<Spacer height={5} />
			<Body size="large" color="primary">
				<Trans
					i18nKey="referrals.affiliates.modal.referrer.mint-message"
					components={[<Emphasis />]}
				/>
			</Body>
			<Spacer height={30} />
			<FlexDivColCentered>
				<BronzeIcon width={240} height={240} />
				<div style={{ width: '45px', marginTop: '-10px' }}>
					<Badge color="yellow">{t('referrals.affiliates.modal.nft-preview.tier-1')}</Badge>
				</div>
			</FlexDivColCentered>
			<Spacer height={30} />
			<Body size="medium" color="primary" style={{ textAlign: 'center' }}>
				<Trans
					i18nKey="referrals.affiliates.modal.referrer.earn-boost"
					components={[<Emphasis />]}
				/>
			</Body>
			<Body size="medium" color="primary" style={{ textAlign: 'center' }}>
				<Trans
					i18nKey="referrals.affiliates.modal.referrer.stake-more"
					components={[<Emphasis />]}
				/>
			</Body>
			<Spacer height={30} />
			<Button
				data-testid="referrals.affiliates.modal.referrer.trade-now-button"
				variant="flat"
				disabled={false}
				loading={false}
				textTransform="none"
				fullWidth
				onClick={() => {}}
			>
				<FlexDivRow columnGap="10px">
					{t('referrals.affiliates.modal.referrer.trade-now-button')}
				</FlexDivRow>
			</Button>
		</FlexDivColCentered>
	)
})

const ReferrerModal: FC<Props> = ({ onDismiss }) => {
	return (
		<StyledBaseModal
			title={<ReferrerHeader />}
			hasHeaderBackground={true}
			isOpen
			onDismiss={onDismiss}
		>
			<Minting />
		</StyledBaseModal>
	)
}

const Emphasis = styled.span`
	color: ${(props) => props.theme.colors.selectedTheme.newTheme.text.preview};
`

const StyledBaseModal = styled(BaseModal)`
	[data-reach-dialog-content] {
		width: 448px;
	}
	.card-header {
		margin-top: 15px;
	}
`

export default ReferrerModal
